@if (isCrossGame) {
  <c-container class="mt-5">
    <h2><span data-testid="game-settings-page-heading">Game Settings</span>
      <!-- The heading text is in its own span so a test can assert the copy directly, rather than
           through the heading's accessible name - the menu button below renders inside this h2. -->
      <!-- Creating Azure resources is the only thing left in this menu now that Recalculate Game Totals has
           gone, so the trigger goes with it. Without this an environment with resource creation turned off
           shows a menu button that opens onto nothing. -->
      @if (allowCreationOfAzureResources) {
        <button mat-icon-button
                data-testid="open-manage-game-options-menu-button"
                id="charity-menu-button"
                *hasPermission="permissionTypes.CausableAdminOnly"
                [matMenuTriggerFor]="menu">
          <mat-icon matTooltipPosition="right"
                    matTooltip="open admin user menu"
          >more_vertical
          </mat-icon>
        </button>
      }
    </h2>

    <mat-card class="mb-4" data-testid="game-settings-choose-game-prompt">
      <mat-card-content>
        <p class="mb-0">Game settings belong to a single game. Pick one from the game selector at the top of
          the page - you will stay on Game Settings.</p>
      </mat-card-content>
    </mat-card>
  </c-container>

  <mat-menu #menu="matMenu">
    @if (allowCreationOfAzureResources) {
      <button mat-menu-item
              (click)="onCreateAzureResourcesClick()"
              id="create-azure-resources-button"
              *hasPermission="permissionTypes.CausableAdminOnly">
        <mat-icon class="dark-grey menu-icon">edit</mat-icon>
        <span class="dark-grey menu-text">Create Azure Resources</span>
      </button>
    }
  </mat-menu>
} @else {
  <c-container>
    @if (activeGame(); as active_game) {
      <app-game-settings [activeGame]="active_game"></app-game-settings>
    }
  </c-container>
}
